import { CouponAlgorithm, CouponScope, DemographicPrice, SelectionState } from "types";

export enum TermsType {
    BASIC = "Basic",
    ADVANCED = "Advanced",
}

export interface TermsTemplate {
    id?: ID;
    title: string;
    products: SelectionState;
    discount: TermsTemplateFee;
    commission: TermsTemplateFee;
    termsType: TermsType;
    partnerDemographicTerms: PartnerDemographicTerm[];
    productTermExceptions: ProductTermException[];
}

export interface PartnerDemographicTerm {
    product: { id: ID; name?: string };
    partnerDemographicPrices: PartnerDemographicPrice[];
}

export interface PartnerDemographicPrice {
    template: { id: ID };
    commission: DemographicPrice;
    discount: DemographicPrice;
}

export interface TermsTemplateFee {
    id?: ID;
    amount: number | null;
    algorithm: CouponAlgorithm;
    scope: CouponScope;
    demographics: SelectionState;
    equipments?: SelectionState;
    includeAddOns: boolean;
    includeCustomLineItems: boolean;
}

export interface ProductTermException {
    id?: ID;
    products: ID[];
    discount: TermsTemplateFee;
    commission: TermsTemplateFee;
    exceptionIndex?: number;
}
